module.exports = __webpack_public_path__ + "static/img/no_data.cc41c130.png";